import { makePost } from './helpers';

type StaticParams = {
    authToken: string;
    deployment: string;
};

export type ReindexResponse = {
    error: boolean;
    meta?: unknown;
    payload?: unknown;
};

const handleReindexResponse = (err: any, response: any, reject: Function, resolve: Function) => {
    if (err || !response?.ok) {
        const msg =
            response?.body?.error ||
            (response?.status ? `HTTP ${response.status}` : 'There was an error with the request');
        return reject(msg);
    }
    resolve(response.body);
};

export const postReindexCatalogs = ({ authToken, catalogIds, deployment }: StaticParams & { catalogIds: number[] }) =>
    new Promise<ReindexResponse>((resolve, reject) => {
        const request = makePost({
            apiPath: 'v2/index/update/catalogs',
            authToken,
            deployment,
            path: '<DEWEY>',
        });
        request.send({ catalogIds });
        request.end((err, response) => handleReindexResponse(err, response, reject, resolve));
    });

export const postReindexLots = ({ authToken, deployment, lotIds }: StaticParams & { lotIds: number[] }) =>
    new Promise<ReindexResponse>((resolve, reject) => {
        const request = makePost({
            apiPath: 'v2/index/update/lots',
            authToken,
            deployment,
            path: '<DEWEY>',
        });
        request.send({ lotIds });
        request.end((err, response) => handleReindexResponse(err, response, reject, resolve));
    });
